import React from 'react';
import PropTypes from 'prop-types';

class BookingsModalHost extends React.Component{

    render() {
        return (
            <div className="tab-panel">
                <div className="column column-wide">
                    <label htmlFor="host">Host</label>
                    <input id="host" defaultValue={this.props.booking.host} onChange={e => this.props.updateBooking("host", e.target.value)} placeholder="Enter name" />

                    <label htmlFor="hostImage">Host image</label>
                    <input id="hostImage" defaultValue={this.props.booking.hostImage} onChange={e => this.props.updateBooking("hostImage", e.target.value)} placeholder="Enter link to host image" />

                    <label htmlFor="hostDescription">Host description</label>
                    <textarea id="hostDescription" defaultValue={this.props.booking.hostDescription} onChange={e => this.props.updateBooking("hostDescription", e.target.value)} placeholder="Enter description"></textarea>
                </div>
            </div>
        );
    }
}

BookingsModalHost.propTypes = {
    booking: PropTypes.object.isRequired,
    updateBooking: PropTypes.func.isRequired
}

export default BookingsModalHost;


/** WEBPACK FOOTER **
 ** ./src/components/BookingsModalHost.js
 **/